export const useStyles = () => ({
  downloadButton: {
    color: '#f50057',
    '&:hover': {
      backgroundColor: '#e1005014',
    },
    '&:focus': {
      backgroundColor: '#e1005014',
    },
  },
  loader: {
    height: '48px',
    width: '48px',
    paddingLeft: '10px',
    display: 'flex',
    alignItems: 'center',
  },
});
